import {
  menuProfilePhotoCaptionEl,
  menuProfilePhotoIconEl,
  menuProfilePhotoImgEl,
  menuProfilePhotoUnameEl,
  playLoginBtnEl,
  signInDialogEl,
} from "./elements";
import { FirebaseAuthentication } from "./plugins";
import {
  emailToUsername,
  setProfileInfoToEls,
  showProfileEditor,
} from "./profileEditor";
import store from "./store";
import { throwErrorWithStack } from "./crashlytics";
import cachedFirestore from "./cachedFirestore";
import { addDocumentSnapshotListeners } from "./snapshotListeners";
import { withSpinner } from "./spinner";
import { getLogger } from "./logging";

const log = getLogger("🔑 Auth");

// if (IS_WEB) {
//   const MEASUREMENT_ID = "G-QT6GMTCE3W";
//   const firebaseConfig = {
//     apiKey: "AIzaSyBhjMps8PRy3C93GsYGIzaZal_MHt7s1vs",
//     authDomain: "chat-noir-hexagon.firebaseapp.com",
//     projectId: "chat-noir-hexagon",
//     storageBucket: "chat-noir-hexagon.appspot.com",
//     messagingSenderId: "364850725471",
//     appId: "1:364850725471:web:0d9fee53228133a01e51ea",
//     measurementId: MEASUREMENT_ID,
//   };
//   firebase.initializeApp(firebaseConfig);
// }

export const signInWithGoogle = async () => {
  const { user, additionalUserInfo } =
    await FirebaseAuthentication.signInWithGoogle();
  log.info(`Signed in with Google as ${user.displayName}`);
  store.set("user", user);
  addDocumentSnapshotListeners();
  if (store.user.uid) {
    playLoginBtnEl.style.display = "none";
    menuProfilePhotoCaptionEl.style.display = "none";
    menuProfilePhotoIconEl.style.display = "none";
    menuProfilePhotoImgEl.src = "img/placeholder.jpg";
    menuProfilePhotoImgEl.style.height = "100%";
  }
  const name = store.user.displayName;
  if (additionalUserInfo.isNewUser) {
    const profile = {
      uid: store.user.uid,
      name,
      thumbnailUrl: store.user.photoUrl || null,
      levelsWonCount: 0,
      levelsCreatedCount: 0,
      lastPostedLevelAt: null,
      followingCount: 0,
      followersCount: 0,
    };
    let data = {
      ...profile,
      timestamp: Date.now(),
      metadata: {
        language: navigator.language || navigator.userLanguage,
      },
    };
    data = Object.fromEntries(
      Object.entries(data).filter(([, v]) => v !== null && v !== undefined)
    );
    if (__DEV__) log.debug("Profile data", data);
    try {
      cachedFirestore.setDocument({
        reference: `profile/${store.user.uid}`,
        data,
      });
    } catch (error) {
      throwErrorWithStack(error, true);
    }
    store.set("profile", profile);
    store.saveAll();
  } else {
    const profile = await cachedFirestore.getDocument({
      reference: `profile/${store.user.uid}`,
      useCache: false,
    });
    await fetchStore();
    store.set("profile", profile || {});
    menuProfilePhotoUnameEl.textContent = store.profile.uname;
  }
  if (!store.profile.uname) {
    log.debug("Profile uname not set");
    if (!store.profile.name) store.profile.name = store.user.displayName;
    store.profile.uname = emailToUsername(store.user.email);
    await withSpinner(
      cachedFirestore.setDocument({
        reference: `profile/${store.user.uid}`,
        data: store.profile,
        merge: true,
      })
    );
    showProfileEditor(true);
  }
  menuProfilePhotoUnameEl.style.display = "block";
  setProfileInfoToEls();
  return user;
};

export async function fetchStore(...timeoutArgs) {
  if (!store.user.uid) return;
  const existingStore = await cachedFirestore.getDocument({
    reference: `store/${store.user.uid}`,
    useCache: false,
    timeoutArgs,
  });
  if (existingStore) {
    const filteredStore = store.filterFirestorable(existingStore);
    store.mergeStore(filteredStore);
  }
}

export async function fetchProfile(...timeoutArgs) {
  if (!store.user.uid) return;
  const profile = await cachedFirestore.getDocument({
    reference: `profile/${store.user.uid}`,
    useCache: false,
    timeoutArgs,
  });
  if (profile) store.set("profile", profile);
}

export const signOut = async () => {
  await FirebaseAuthentication.signOut();
  store.set("user", {});
  store.set("profile", {});
  playLoginBtnEl.style.display = null;
  menuProfilePhotoCaptionEl.style.display = null;
  menuProfilePhotoIconEl.style.display = null;
  menuProfilePhotoImgEl.removeAttribute("src");
  menuProfilePhotoUnameEl.style.display = "none";
  menuProfilePhotoImgEl.style.height = null;
};

export function requireAuth(func) {
  return (...args) => {
    if (store.user.uid) return func(...args);
    else signInDialogEl.style.display = "initial";
  };
}

if (__DEV__) {
  window.signOut = signOut;
  window.fetchStore = fetchStore;
}
